import { Observable } from 'rxjs';
import { Third, CatalogItem, Municipality } from '../third';

export abstract class ThirdsRepository {
  abstract get(uid: string, cid: string | null, type: string, page?: number, limit?: number, search?: any[]): Observable<Third[]>;
  abstract create(uid: string, cid: string | null, data: Third, type: string): Observable<any>;
  abstract edit(uid: string, cid: string | null, data: Third, id: number | string): Observable<any>;
  abstract getById(uid: string, cid: string | null, id: string | number): Observable<Third>;
  abstract getByIdentification(uid: string, cid: string | null, identification: string): Observable<Third>;
  abstract delete(uid: string, cid: string | null, id: string | number): Observable<any>;
  abstract inactivate(uid: string, cid: string | null, id: string | number): Observable<any>;
  abstract reactivate(uid: string, cid: string | null, id: string | number): Observable<any>;

  // Catalogs
  abstract getIdentificationTypes(uid: string, cid: string | null): Observable<CatalogItem[]>;
  abstract getOrganizations(uid: string, cid: string | null): Observable<CatalogItem[]>;
  abstract getLiabilities(uid: string, cid: string | null): Observable<CatalogItem[]>;
  abstract getRegimes(uid: string, cid: string | null): Observable<CatalogItem[]>;
  abstract getMunicipalities(uid: string, cid: string | null, query?: string): Observable<Municipality[]>;
}
